export default class Data {
  private _raw: any;
  private _clean: any;

  constructor(data?: any) {
    this._raw = data ?? [];

    // TODO: should be able to consume options
    // for "how to make" the clean data
    this._clean = data ?? [];
  }

  public consumeByField(field: string) {
    if (Array.isArray(this._clean)) {
      return this._clean.map((d) => d[field]);
    }

    return this._clean;
  }

  public consume() {
    return this._clean;
  }
}
